import { graphql, useStaticQuery } from "gatsby"

export const useAllAbout = (locale) => {
  const { allCosmicjsAbout } = useStaticQuery(graphql`
    query {
      allCosmicjsAbout {
        edges {
          node {
            id
            slug
            title
            locale
            type
            content
          }
        }
      }
    }
  `)

  const allItems = allCosmicjsAbout.edges.map(({ node }, index) => ({
    key: index,
    ...node,
  }))

  if (!locale) {
    return allItems
  }

  return allItems.filter((item) => item.locale === locale)
}
